import type { CSSProperties } from 'react';
import { getFontFamily } from '@/theme/typography';

export const COMPACT_PREVIEW_ROOT_STYLE: CSSProperties = {
  position: 'absolute',
  inset: 0,
  overflow: 'hidden',
};

export const COMPACT_PREVIEW_SPARK_WRAP_STYLE: CSSProperties = {
  position: 'absolute',
  inset: 0,
};

export const COMPACT_PREVIEW_HERO_STYLE: CSSProperties = {
  position: 'absolute',
  top: 20,
  left: 24,
  zIndex: 10,
};

export const COMPACT_PREVIEW_CONTEXT_STYLE: CSSProperties = {
  fontFamily: getFontFamily(),
  fontSize: 13,
  fontWeight: 500,
  color: 'rgba(255, 255, 255, 0.65)',
  marginBottom: 4,
};

export const COMPACT_PREVIEW_TITLE_STYLE: CSSProperties = {
  color: 'rgba(255, 255, 255, 0.45)',
  marginLeft: 8,
};

export const COMPACT_PREVIEW_VALUE_ROW_STYLE: CSSProperties = {
  display: 'flex',
  alignItems: 'baseline',
  gap: 10,
};

export const COMPACT_PREVIEW_VALUE_STYLE: CSSProperties = {
  fontFamily: getFontFamily(),
  fontSize: 46,
  fontWeight: 700,
  letterSpacing: '-0.04em',
  lineHeight: 1,
  color: '#ffffff',
  textShadow: '0 4px 16px rgba(0,0,0,0.4)',
};

export const COMPACT_PREVIEW_DELTA_PERCENT_STYLE: CSSProperties = {
  opacity: 0.8,
};

export const COMPACT_PREVIEW_SPARK_SVG_STYLE: CSSProperties = {
  position: 'absolute',
  inset: 0,
  display: 'block',
};

interface BuildCompactPreviewColorStyleInput {
  color: string;
}

export function buildCompactPreviewSeriesLabelStyle({
  color,
}: BuildCompactPreviewColorStyleInput): CSSProperties {
  return {
    fontFamily: getFontFamily(),
    fontSize: 18,
    fontWeight: 600,
    color,
    opacity: 0.9,
    letterSpacing: '-0.01em',
    textShadow: '0 2px 8px rgba(0,0,0,0.4)',
  };
}

export function buildCompactPreviewDeltaStyle({
  color,
}: BuildCompactPreviewColorStyleInput): CSSProperties {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 10,
    fontFamily: getFontFamily(),
    fontSize: 15,
    fontWeight: 600,
    color,
    textShadow: '0 2px 8px rgba(0,0,0,0.5)',
  };
}
